import { IBreadcrumbsItem } from 'common/core/interfaces/breadcrumbsItem'

export const InstagramSettingsItem: IBreadcrumbsItem = {
  label: 'Instagram Settings',
  path: 'settings#instagram',
}
